export default __webpack_public_path__ + "static/media/arrow-gray-small-right.3e14e7eb.svg";